// services/websocketService.js
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { DATA_SAVE_URL } from "../scenes/utils/UrlHandle";

class WebSocketService {
  constructor() {
    this.client = null;
    this.subscriptions = new Map();
  }

  connect(onConnect, onError) {
    this.client = new Client({
      webSocketFactory: () => new SockJS(DATA_SAVE_URL + "/ws"),
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => {
        console.log("Connected to WebSocket");
        if (onConnect) onConnect();
      },
      onStompError: (frame) => {
        console.error("WebSocket error:", frame);
        if (onError) onError(frame);
      },
    });

    this.client.activate();
  }

  subscribeToNotifications(callback) {
    if (!this.client || !this.client.connected) {
      console.error("WebSocket not connected");
      return;
    }

    const subscription = this.client.subscribe(
      "/topic/notifications",
      (message) => {
        const notification = JSON.parse(message.body);
        callback("NEW_NOTIFICATION", notification);
      }
    );

    this.subscriptions.set("notifications", subscription);
  }

  subscribeToNotificationUpdates(callback) {
    if (!this.client || !this.client.connected) {
      console.error("WebSocket not connected");
      return;
    }

    const subscription = this.client.subscribe(
      "/topic/notifications-update",
      (message) => {
        const notification = JSON.parse(message.body);
        callback("UPDATE_NOTIFICATION", notification);
      }
    );

    this.subscriptions.set("notifications-update", subscription);
  }

  subscribeToBulkUpdates(callback) {
    if (!this.client || !this.client.connected) {
      console.error("WebSocket not connected");
      return;
    }

    const subscription = this.client.subscribe(
      "/topic/notifications-bulk-update",
      (message) => {
        const notificationIds = JSON.parse(message.body);
        callback("BULK_UPDATE", notificationIds);
      }
    );

    this.subscriptions.set("notifications-bulk-update", subscription);
  }

  disconnect() {
    if (this.client) {
      this.subscriptions.forEach((subscription) => subscription.unsubscribe());
      this.subscriptions.clear();
      this.client.deactivate();
    }
  }
}

export default new WebSocketService();
